import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";


const initialReports = {
  records: 1,
  paymentType: "ALL",
  facilityId: 0,
  actions: 2,
  fromDate: "",
  toDate: "",
  dobEndDate: "",
  year: 0,
  month: 0,
  transactionSucess: 2,
  pageNo: 1,
  rowCountPerPage: 10,
  firstName: "",
  firstNameValue: 0,
  lastName: "",
  lastNameValue: 0,
  inmateResidentID: "",
  taskNo: 0,
  refundTaskNo: 0,
  sortBy: "",
};

const initialRecords = [
  { value: 1, label: "All" },
  { value: 2, label: "Facility" },
];
const initialActions = [
  { value: 1, label: "Daily" },
  { value: 2, label: "Monthly" },
  { value: 3, label: "Range" },
];
const initialPaymentTypeOption = [
  { value: "ALL", label: "-- ALL --" },
  { value: "PAYPAL", label: "PAYPAL" },
  { value: "STRIPE", label: "STRIPE" },
  { value: "IOSInAPP", label: "IOSInAPP" },
  { value: "Google", label: "GOOGLE" }
];


const initialMonthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

// Create slice

const name = "revenueReporting";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// Exports
export const revenueReportingActions = { ...slice.actions, ...extraActions };
export const revenueReportingReducer = slice.reducer;

// Implementation

function createInitialState() {
  return {
    isPageScroll: 0,
    reports: initialReports,
    revenueSummaryList: {},
    monthlyPOtransaction: {},
    dailyPOtransaction: {},
    userPaymentInfo: {},
    monthlyFCList: {},
    dailyFCList: {},
    monthlyCCList: {},
    dailyCCList: {},
    dicrepancyCRFList: {},
    inmateFN: [],
    inmateLN: [],
    POTransStatusUpdate: [],
    POTpaymentUpdate: [],
    dataTableData: [],
    loading: false,
    error: null,
    paymentTypeOption: initialPaymentTypeOption,
    actions: initialActions,
    records: initialRecords,
    monthNames: initialMonthNames,
  };
}

function createReducers() {
  return {
    ClearRevenueSummaryList,
    ClearPOTransStatusUpdate,
    ClearPOTpaymentUpdate,
    setReports,
    resetRevenueReports,
    updateScroll
  };
  /// clear funcs

  function updateScroll(state, action) {
    state.isPageScroll = action.payload && action.payload;
  }

  function ClearRevenueSummaryList(state) {
    state.revenueSummaryList = {};
  }
  function ClearPOTransStatusUpdate(state) {
    state.POTransStatusUpdate = [];
  }
  function ClearPOTpaymentUpdate(state) {
    state.POTpaymentUpdate = [];
  }
  function setReports(state, action) {
    state.reports = action && action.payload;
  }
  function resetRevenueReports(state) {
    state.reports = { ...initialReports };
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser/RevenueReport`;
  const PurchaseCreditsbaseUrl = `${process.env.REACT_APP_API_URL}/PublicUser/PurchaseCredits`;

  return {
    GetRevenueSummaryList: GetRevenueSummaryList(),
    LoadMonthlyPurchaseOrderTransactionList:
      LoadMonthlyPurchaseOrderTransactionList(),
    LoadDailyPurchaseOrderTransactionList:
      LoadDailyPurchaseOrderTransactionList(),
    GetUserPaymentInfo: GetUserPaymentInfo(),
    LoadMonthlyFreeCreditsList: LoadMonthlyFreeCreditsList(),
    LoadDailyFreeCreditsList: LoadDailyFreeCreditsList(),
    LoadDailyCactasCreditsList: LoadDailyCactasCreditsList(),
    LoadMonthlyCactasCreditsList: LoadMonthlyCactasCreditsList(),
    LoadDicrepancyCactasRefundDetailsList:
      LoadDicrepancyCactasRefundDetailsList(),
    LoadInmateFirstNames: LoadInmateFirstNames(),
    LoadInmateLastNames: LoadInmateLastNames(),
    PurchaseOrderTransactionStatusUpdate:
      PurchaseOrderTransactionStatusUpdate(),
    POTPaymantTrasactionUpdate: POTPaymantTrasactionUpdate(),
    SendMailForFailedTransaction: SendMailForFailedTransaction(),
  };

  // load RevenueSummaryList
  function GetRevenueSummaryList() {
    return createAsyncThunk(`${name}/GetRevenueSummaryList`, async (params) => {
      const { facilityId, paymentType, fromDate, toDate } = params;
      //   return await fetchWrapper.get(`${baseUrl}/GetRevenueSummaryList`, params);
      return await fetchWrapper.get(
        `${baseUrl}/GetRevenueSummaryList?facilityId=${facilityId}&paymentType=${paymentType}&fromDate=${fromDate}&toDate=${toDate}`
      );
    });
  }
  function SendMailForFailedTransaction() {
    return createAsyncThunk(
      `${name}/SendMailForFailedTransaction`,
      async (addFormData) =>
        await fetchWrapper.post(
          `${PurchaseCreditsbaseUrl}/SendMailForFailedTransaction`,
          addFormData
        )
    );
  }

  // Load monthly PO List
  function LoadMonthlyPurchaseOrderTransactionList() {
    return createAsyncThunk(
      `${name}/LoadMonthlyPurchaseOrderTransactionList`,
      async (params) => {
        return await fetchWrapper.post(
          `${baseUrl}/LoadMonthlyPurchaseOrderTransactionList`,
          params
        );
      }
    );
  }
  // Load Daily PO List
  function LoadDailyPurchaseOrderTransactionList() {
    return createAsyncThunk(
      `${name}/LoadDailyPurchaseOrderTransactionList`,
      async (params) => {
        return await fetchWrapper.post(
          `${baseUrl}/LoadDailyPurchaseOrderTransactionList`,
          params
        );
      }
    );
  }

  // Click Po list
  function GetUserPaymentInfo() {
    return createAsyncThunk(
      `${name}/GetUserPaymentInfo`,
      async (purchaseOrderTransactionID) => {
        return await fetchWrapper.get(
          `${baseUrl}/GetUserPaymentInfo?purchaseOrderTransactionID=${purchaseOrderTransactionID}`
        );
      }
    );
  }
  // load monthly FC List
  function LoadMonthlyFreeCreditsList() {
    return createAsyncThunk(
      `${name}/LoadMonthlyFreeCreditsList`,
      async (params) => {
        return await fetchWrapper.post(
          `${baseUrl}/LoadMonthlyFreeCreditsList`,
          params
        );
      }
    );
  }

  // Load Daily FC List
  function LoadDailyFreeCreditsList() {
    return createAsyncThunk(
      `${name}/LoadDailyFreeCreditsList`,
      async (params) => {
        return await fetchWrapper.post(
          `${baseUrl}/LoadDailyFreeCreditsList`,
          params
        );
      }
    );
  }

  //Load Daily CC List
  function LoadDailyCactasCreditsList() {
    return createAsyncThunk(
      `${name}/LoadDailyCactasCreditsList`,
      async (params) => {
        return await fetchWrapper.post(
          `${baseUrl}/LoadDailyCactasCreditsList`,
          params
        );
      }
    );
  }

  // Load Monthly CC List
  function LoadMonthlyCactasCreditsList() {
    return createAsyncThunk(
      `${name}/LoadMonthlyCactasCreditsList`,
      async (params) => {
        return await fetchWrapper.post(
          `${baseUrl}/LoadMonthlyCactasCreditsList`,
          params
        );
      }
    );
  }
  // Load CCF List
  function LoadDicrepancyCactasRefundDetailsList() {
    return createAsyncThunk(
      `${name}/LoadDicrepancyCactasRefundDetailsList`,
      async (params) => {
        return await fetchWrapper.post(
          `${baseUrl}/LoadDicrepancyCactasRefundDetailsList`,
          params
        );
      }
    );
  }

  // Load Inmate FN
  function LoadInmateFirstNames() {
    return createAsyncThunk(`${name}/LoadInmateFirstNames`, async (params) => {
      return await fetchWrapper.post(`${baseUrl}/LoadInmateFirstNames`, params);
    });
  }
  // Load Inmate LN
  function LoadInmateLastNames() {
    return createAsyncThunk(`${name}/LoadInmateLastNames`, async (params) => {
      return await fetchWrapper.post(`${baseUrl}/LoadInmateLastNames`, params);
    });
  }
  //
  function PurchaseOrderTransactionStatusUpdate() {
    return createAsyncThunk(
      `${name}/PurchaseOrderTransactionStatusUpdate`,
      async (params) => {
        return await fetchWrapper.post(
          `${baseUrl}/PurchaseOrderTransactionStatusUpdate`,
          params
        );
      }
    );
  }
  function POTPaymantTrasactionUpdate() {
    return createAsyncThunk(
      `${name}/POTPaymantTrasactionUpdate`,
      async (params) => {
        const { IsPaymentIntentMethod, date, transactionRandomID, TransactionEmail, paymentType } = params;
        return await fetchWrapper.post(
          `${baseUrl}/POTPaymantTrasactionUpdate?IsPaymentIntentMethod=${IsPaymentIntentMethod}&date=${date}&transactionRandomID=${transactionRandomID}&TransactionEmail=${TransactionEmail}&paymentType=${paymentType}`
        );
      }
    );
  }
}

function createExtraReducers(builder) {
  builder
    //
    .addCase(extraActions.GetRevenueSummaryList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetRevenueSummaryList.fulfilled, (state, action) => {
      state.loading = false;
      state.revenueSummaryList = action.payload;
    })
    .addCase(extraActions.GetRevenueSummaryList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })
    // //
    .addCase(
      extraActions.LoadMonthlyPurchaseOrderTransactionList.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadMonthlyPurchaseOrderTransactionList.fulfilled,
      (state, action) => {
        state.loading = false;
      }
    )
    .addCase(
      extraActions.LoadMonthlyPurchaseOrderTransactionList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    // ///
    .addCase(
      extraActions.LoadDailyPurchaseOrderTransactionList.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )

    .addCase(
      extraActions.LoadDailyPurchaseOrderTransactionList.fulfilled,
      (state, action) => {
        state.loading = false;
        state.dailyPOtransaction = action.payload;
      }
    )
    .addCase(
      extraActions.LoadDailyPurchaseOrderTransactionList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    // ///
    .addCase(extraActions.GetUserPaymentInfo.pending, (state) => {
      state.userPaymentInfo.loading = true;
      state.error = null;
    })

    .addCase(extraActions.GetUserPaymentInfo.fulfilled, (state, action) => {
      state.userPaymentInfo = action.payload;
      state.userPaymentInfo.loading = false;
    })
    .addCase(extraActions.GetUserPaymentInfo.rejected, (state, action) => {
      state.userPaymentInfo.loading = false;
      state.error = action.error;
    })

    // ///
    .addCase(extraActions.LoadMonthlyFreeCreditsList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(
      extraActions.LoadMonthlyFreeCreditsList.fulfilled,
      (state, action) => {
        state.loading = false;
        state.monthlyFCList = action.payload;
      }
    )
    .addCase(
      extraActions.LoadMonthlyFreeCreditsList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    // ///
    .addCase(extraActions.LoadDailyFreeCreditsList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(
      extraActions.LoadDailyFreeCreditsList.fulfilled,
      (state, action) => {
        state.loading = false;
        state.dailyFCList = action.payload;
      }
    )
    .addCase(
      extraActions.LoadDailyFreeCreditsList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    // ///
    .addCase(extraActions.LoadDailyCactasCreditsList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(
      extraActions.LoadDailyCactasCreditsList.fulfilled,
      (state, action) => {
        state.loading = false;
        state.dailyCCList = action.payload;
      }
    )
    .addCase(
      extraActions.LoadDailyCactasCreditsList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    // ///
    .addCase(extraActions.LoadMonthlyCactasCreditsList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(
      extraActions.LoadMonthlyCactasCreditsList.fulfilled,
      (state, action) => {
        state.loading = false;
        state.monthlyCCList = action.payload;
      }
    )
    .addCase(
      extraActions.LoadMonthlyCactasCreditsList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    // ///
    .addCase(
      extraActions.LoadDicrepancyCactasRefundDetailsList.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )

    .addCase(
      extraActions.LoadDicrepancyCactasRefundDetailsList.fulfilled,
      (state, action) => {
        state.loading = false;
        state.dicrepancyCRFList = action.payload;
      }
    )
    .addCase(
      extraActions.LoadDicrepancyCactasRefundDetailsList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    // ///
    .addCase(extraActions.LoadInmateFirstNames.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.LoadInmateFirstNames.fulfilled, (state, action) => {
      state.loading = false;
      state.inmateFN = action.payload;
    })
    .addCase(extraActions.LoadInmateFirstNames.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    // ///
    .addCase(extraActions.LoadInmateLastNames.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.LoadInmateLastNames.fulfilled, (state, action) => {
      state.loading = false;
      state.inmateLN = action.payload;
    })
    .addCase(extraActions.LoadInmateLastNames.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    // ///
    .addCase(
      extraActions.PurchaseOrderTransactionStatusUpdate.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )

    .addCase(
      extraActions.PurchaseOrderTransactionStatusUpdate.fulfilled,
      (state, action) => {
        state.loading = false;
        state.POTransStatusUpdate = action.payload;
      }
    )
    .addCase(
      extraActions.PurchaseOrderTransactionStatusUpdate.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    // ///
    .addCase(extraActions.POTPaymantTrasactionUpdate.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(
      extraActions.POTPaymantTrasactionUpdate.fulfilled,
      (state, action) => {
        state.loading = false;
        state.POTpaymentUpdate = action.payload;
      }
    )
    .addCase(
      extraActions.POTPaymantTrasactionUpdate.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    );
}
